import React, { createContext, useState } from 'react';

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(false);
  const [title, setTitle] = useState(false);
  return (
    <ModalContext.Provider value={{ open, setOpen, content, setContent, title, setTitle }}>
      {children}
    </ModalContext.Provider>
  );
};
